import { Component, OnInit } from '@angular/core';
import { FormBuilder,  FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent implements OnInit{

  firstFormGroup: FormGroup;
  isDirty = false; // Set to true when user changes something

  constructor(private _formBuilder: FormBuilder, private router: Router) {
    this.firstFormGroup = this._formBuilder.group({
      hasURN: [''] 
    });

    this.firstFormGroup.valueChanges.subscribe(() => {
      this.isDirty = true;
    });
  }

  ngOnInit() { }

  onSelectionChange(): void {
    const hasURN = this.firstFormGroup.value.hasURN;
    if (hasURN === 'yes') {
      sessionStorage.setItem('registerCompleted', 'true');
         this.router.navigate(['/msmeuserverification']);
    } else if (hasURN === 'no') {
      window.open('https://udyamregistration.gov.in/Government-India/Ministry-MSME-registration.htm', '_blank');
    }
  }
  
}
